import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

export default function Layout() {
  const { user, logout, can } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);           // mobile drawer
  const [reports, setReports] = useState([]);
  const [progs, setProgs] = useState({ viewAll: false, programmes: [] });
  const [activeProg, setActiveProg] = useState(() => localStorage.getItem('bsp2_active_prog') || 'all');

  // Load the report catalogue so each report is its own sidebar link.
  useEffect(() => {
    if (can('report.view')) api.get('/reports').then(r => setReports(r.data)).catch(() => {});
    api.get('/my-programmes').then(r => setProgs(r.data)).catch(() => {});
  }, [can]);

  const changeProg = v => { setActiveProg(v); localStorage.setItem('bsp2_active_prog', v); window.dispatchEvent(new Event('bsp2-prog-change')); };

  // Close the drawer whenever the route changes (tapping a link on mobile).
  useEffect(() => { setOpen(false); }, [loc.pathname, loc.search]);

  const showAdmin = can('user.view') || can('user.manage') || can('role.manage');

  // Group reports by category for the sidebar.
  const byCat = {};
  reports.forEach(r => { (byCat[r.category] = byCat[r.category] || []).push(r); });

  return (
    <div className="app">
      {open && <div className="sidebar-backdrop show" onClick={() => setOpen(false)} />}
      <aside className={`sidebar${open ? ' open' : ''}`}>
        <div className="brand"><strong>Building Safety</strong><span>Programme Tracker</span></div>
        <nav>
          <div className="sect">Delivery</div>
          {can('dashboard.view') && <NavLink to="/" end>Dashboard</NavLink>}
          {can('programme.view') && <NavLink to="/programmes">Programmes</NavLink>}
          {can('expenditure.view') && <NavLink to="/budget">Budget &amp; expenditure</NavLink>}

          {can('report.view') && <>
            <div className="sect">Reports</div>
            {reports.length === 0 && <NavLink to="/reports">All reports</NavLink>}
            {Object.keys(byCat).sort().map(cat => (
              <React.Fragment key={cat}>
                {reports.map(r => r.category === cat ? (
                  <NavLink key={r.key} to={`/reports/${r.key}`} title={r.description}>{r.title}</NavLink>
                ) : null)}
              </React.Fragment>
            ))}
          </>}

          {showAdmin && <>
            <div className="sect">Administration</div>
            {(can('user.view') || can('user.manage')) && <NavLink to="/admin/users">Users</NavLink>}
            {can('role.manage') && <NavLink to="/admin/roles">Roles &amp; permissions</NavLink>}
          </>}
        </nav>
        <div className="suser">
          <strong>{user?.fullName}</strong><span>{(user?.roles || []).join(', ')}</span>
          <button onClick={() => { logout(); nav('/login'); }}>Sign out</button>
        </div>
      </aside>

      <div className="main">
        <div className="topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <button className="menu-toggle" onClick={() => setOpen(o => !o)} aria-label="Menu">☰</button>
            <span className="topbar-title">BSP Tracker</span>
          </div>
          {progs.programmes.length > 1 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span className="muted" style={{ fontSize: 12 }}>Programme:</span>
              <select value={activeProg} onChange={e => changeProg(e.target.value)} style={{ height: 30, fontSize: 12.5, maxWidth: 220 }}>
                {(progs.viewAll || user?.roles?.includes('Administrator')) && <option value="all">All programmes</option>}
                {progs.programmes.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
          )}
          <div className="muted">{user?.organisation}</div>
          <div className="muted">{new Date().toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</div>
        </div>
        <div className="content"><Outlet /></div>
      </div>
    </div>
  );
}
